// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__6NwCb","author":"Table_author__12AdM","authorImage":"Table_authorImage__3gjNL","unreadRow":"Table_unreadRow__3EbT_"};